import { Tooltip } from '@dev-spendesk/grapes';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';

type Props = {
  text: string | React.ReactNode;
  tooltipMaxWidth?: number;
  className?: string;
  placement?: 'left' | 'right' | 'top' | 'bottom';
};

export const EllipsisTooltip = ({
  text,
  className,
  tooltipMaxWidth,
  placement,
  ...rest
}: Props) => {
  const [element, setElement] = useState<HTMLDivElement | null>(null);
  const [hasTooltip, setHasTooltip] = useState(false);

  useEffect(() => {
    if (element) {
      setHasTooltip(element.scrollWidth > element.offsetWidth);
    }
  }, [element?.scrollWidth]);

  if (hasTooltip) {
    return (
      <Tooltip
        content={<div className="break-all">{text}</div>}
        maxWidth={tooltipMaxWidth}
        placement={placement}
        triggerAsChild
        {...rest}
      >
        <div className={classNames('truncate', className)}>{text}</div>
      </Tooltip>
    );
  }

  return (
    <div ref={setElement} className={classNames('truncate', className)}>
      {text}
    </div>
  );
};
